module.exports = __webpack_public_path__ + "static/media/solidity-expert.7a7a20a9.png";